import Axios from "../../utils/axiosInstance";

export const getMyPresenceStatus = () => {
    return Axios.get("/api/Presence/GetMyStatus");
};

export const setPresenceStatus = (status, message) => {
    return Axios.post("/api/Presence/SetStatus", { status, oooMessage: message });
};

export const getPresenceStatuses = (repIds) => {
    return Axios.get("/api/Presence/GetStatuses", { params: { repIds: repIds.join(",") } });
};
